import { useState, useEffect } from "react"
import { DetailPage, Row } from "../../components/crud/DetailPage"
import { FkLink, ListPage } from "../../components/crud/ListPage"
import { AsyncSelect, Checkbox, MoneyInput, NumberInput, Select, TextInput } from "../../components/forms/Inputs"
import { useApi } from "../../hooks/useApi"
import { useTranslations } from "../../layers/Localization"
import { useOptions } from "../../hooks/useOptions"
import { getTotalsFactureDetail } from "./FacturesDetail"
import { Currency, toCurrency } from "../../hooks/helpers"
import { useCodesTvaOptions } from "./Articles"
import { useParams } from "react-router-dom"
import { useRegimeTvaOptions } from "./Clients"

function NotesDeCreditDetailFields({ item, set }) {
    const codesTvaOptions = useCodesTvaOptions()
    const [noteDeCredit, setNoteDeCredit] = useState()

    const t = useTranslations()
    const api = useApi()
    const { id } = useParams()
    const articleOptions = useOptions('articles', 'nom')
    const chantiersOptions = useOptions('chantiers', ['nom', 'descriptionFacture'], { query: noteDeCredit ? `clientId=${noteDeCredit.clientId}` : '' })
    const regimeTvaOptions = useRegimeTvaOptions()

    useEffect(() => {
        if (id === 'new' && item.notesDeCreditId) api.get(`/notesDeCreditDetail?notesDeCreditId=${item.notesDeCreditId}`).then(factureDetails => {
            if (!item.ordre) set('ordre')(Math.max(...factureDetails.map(x => x.ordre), 0) + 1)
        })
    }, [id, item.notesDeCreditId])

    useEffect(() => {
        if (item.notesDeCreditId) api.get(`/notesDeCredit/${item.notesDeCreditId}`).then(setNoteDeCredit)
    }, [item.notesDeCreditId])
    useEffect(() => {
        if (!item.codeTva && noteDeCredit?.clientRegimeTva) {
            set('codeTva')(regimeTvaOptions.find(x => x.value === noteDeCredit?.clientRegimeTva).codeTva)
        }
    }, [noteDeCredit?.clientRegimeTva])

    const changeChantier = (id, chantier) => {
        set('chantierId')(id)
        if (id) {
            if (item.articleId) set('articleId')(null)
            set('prixUnitaire')(chantier.prixVente)
            set('nom')(chantier.descriptionFacture.toUpperCase())
        } else {
            set('prixUnitaire')(null)
            set('nom')(null)
        }
    }
    const changeArticle = (id, article) => {
        set('articleId')(id)
        if (id) {
            if (item.chantierId) set('chantierId')(null)
            set('prixUnitaire')(article.prixVente)
            set('nom')(article.nom.toUpperCase())
        } else {
            set('prixUnitaire')(null)
            set('nom')(null)
        }
    }
    const onNomChange = value => {
        set('nom')(value.toUpperCase())
    }

    return <>
        <Row>
            <NumberInput label={t("Ordre")} value={item.ordre} onChange={set('ordre')} required />
            <AsyncSelect className="grow" label={t("Chantier")} value={item.chantierId} onChange={changeChantier} options={chantiersOptions} />
            <AsyncSelect className="grow" label={t("Article")} value={item.articleId} onChange={changeArticle} options={articleOptions} />
        </Row>
        <TextInput label={t("Désignation")} value={item.nom} onChange={onNomChange} required />
        <Row>
            <MoneyInput label={t("Prix unitaire")} value={item.prixUnitaire} onChange={set('prixUnitaire')} required min={item.exportPopsy ? "0.01" : "0"} />
            <NumberInput label={t("Quantité")} value={item.quantite} onChange={set('quantite')} required min={item.exportPopsy ? "1" : "0"} />
            <Select label={t("Code TVA")} value={item.codeTva} onChange={set('codeTva')} options={codesTvaOptions} required />
        </Row>
        <Checkbox label={t("Export Popsy")} value={item.exportPopsy} onChange={set('exportPopsy')} />
        <hr />
        <div className="flex">
            <div className="grid grid-cols-2 gap-x-8 gap-y-3">
                <div className="font-bold">{t("Total HTVA")} :</div>
                <div>{toCurrency(getTotalsFactureDetail(item, codesTvaOptions).totalHtva || 0)}</div>
                <div className="font-bold">{t("Total TVA")} :</div>
                <div>{toCurrency(getTotalsFactureDetail(item, codesTvaOptions).totalTva || 0)}</div>
                <div className="font-bold">{t("Total TTC")} :</div>
                <div>{toCurrency(getTotalsFactureDetail(item, codesTvaOptions).totalTtc || 0)}</div>
            </div>
        </div>
    </>
}

export function NotesDeCreditDetailList(props) {
    const codesTvaOptions = useCodesTvaOptions()
    const t = useTranslations()

    return <ListPage model="notesDeCreditDetail" title={t("Détails")} columns={{
        [t('Ordre')]: 'ordre',
        [t('Désignation')]: 'nom',
        [t('Quantité')]: 'quantite',
        [t('Prix unitaire')]: { sort: 'prixUnitaire', value: item => <Currency value={item.prixUnitaire} /> },
        [t('Code TVA')]: { sort: 'codeTva', value: item => <FkLink>{codesTvaOptions.find(x => x.value === item.codeTva).label}</FkLink> },
        [t('Total HTVA')]: { value: item => <Currency value={getTotalsFactureDetail(item, codesTvaOptions).totalHtva} /> },
        [t('Total TTC')]: { value: item => <Currency value={getTotalsFactureDetail(item, codesTvaOptions).totalTtc} /> },
    }} {...props} />
}

export function NotesDeCreditDetailDetail(props) {
    const t = useTranslations()
    return <DetailPage model="notesDeCreditDetail" title={t("Détail")} Fields={NotesDeCreditDetailFields} defaults={{
        exportPopsy: true,
        quantite: 1,
    }}  {...props} />
}
